import { render } from "./client.vue?vue&type=template&id=05fdf3c1&scoped=true&ts=true"
import script from "./client.vue?vue&type=script&lang=ts"
export * from "./client.vue?vue&type=script&lang=ts"

import "./client.vue?vue&type=style&index=0&id=05fdf3c1&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fdf3c1"]])

export default __exports__